module.exports = __webpack_public_path__ + "static/media/skiing_icon-01.ef37596b.png";